import React from 'react';
import PropTypes from 'prop-types';
import TextButton from 'src/components/TextButton';

const propTypes = {
  openModal: PropTypes.func,
};

const ReportUserButton = ({openModal}) => (
  <TextButton
    onClick={openModal}
    aria-label="Report User (opens dialog)"
    className="red report-user-button"
  >
    Report User
  </TextButton>
);

ReportUserButton.propTypes = propTypes;

export default ReportUserButton;
